import { Department } from '@/features/departments/types/department'
import { Building } from '@/features/floormaps/types/building'
import { Gateway } from '@/features/gateways/types/gateway'
import { ItemLocation } from '@/features/item-location/types/item-location'
import { Dot, Shape } from '../types/shape'
import { parsePoint, parseShapePoints } from './mapParsers'

export type GatewayColors = {
  BLE: string
  RFID: string
}

export function mapDepartmentToShape(department: Department, color: string): Shape | null {
  if (!department.shape) return null

  return {
    id: department.id,
    label: department.name,
    entityType: 'department',
    color,
    points: parseShapePoints(department.shape),
  }
}

export function mapBuildingToShape(building: Building, color: string): Shape | null {
  if (!building.shape) return null

  return {
    id: building.id,
    label: building.name,
    entityType: 'building',
    color,
    points: parseShapePoints(building.shape),
  }
}

export function mapGatewayToDot(gateway: Gateway, colors: GatewayColors): Dot | null {
  const point = parsePoint(gateway.coordinates)

  if (!point) return null

  return {
    id: gateway.id,
    label: gateway.name,
    dotType: 'gateway',
    gatewayType: gateway.type,
    color: colors[gateway.type],
    point,
    departmentId: gateway?.departmentId ?? '',
    referenceId: gateway?.externalId ?? '',
  }
}

export function mapLocationToDot(location: ItemLocation, label: string, isSelected: boolean): Dot | null {
  const point = parsePoint(location.coordinates)

  if (!point) return null

  return {
    id: location.id,
    label,
    dotType: 'gateway',
    color: isSelected ? 'green' : 'blue',
    point,
  }
}
